import { graphql, useMutation } from "react-relay";
import { useIntl } from "react-intl";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useAlert } from "@/src/common/Alert";
import { useDeleteEmployeeRoleAlertMutation } from "./__generated__/useDeleteEmployeeRoleAlertMutation.graphql";

function useDeleteEmployeeRole(props: { id: string; onCompleted: () => void }) {
  const intl = useIntl();
  const Alert = useAlert();
  const [deleteRole] = useMutation<useDeleteEmployeeRoleAlertMutation>(graphql`
    mutation useDeleteEmployeeRoleAlertMutation($id: ID!) {
      store {
        employeeRole(id: $id) {
          delete {
            success
            deletedRoleId @deleteRecord
          }
        }
      }
    }
  `);
  return () => {
    deleteRole({
      variables: {
        id: props.id,
      },
      onCompleted: props.onCompleted,
      onError: () => {
        Alert.alert(
          intl.formatMessage({
            defaultMessage: "Failed to delete role",
            description: "EmployeeRoleEdit: Delete error title",
          })
        );
      },
    });
  };
}

export function useDeleteEmployeeRoleAlert(props: {
  id: string;
  name: string;
  onCompleted: () => void;
}) {
  const intl = useIntl();
  const intl_tokens = useIntlTokens();
  const Alert = useAlert();
  const onDelete = useDeleteEmployeeRole({
    id: props.id,
    onCompleted: props.onCompleted,
  });

  const alertTitle = intl.formatMessage(
    {
      defaultMessage: "Delete {roleName}",
      description: "EmployeeRole delete alert title",
    },
    {
      roleName: props.name,
    }
  );

  const deleteOptionTitle = intl.formatMessage({
    defaultMessage: "Delete",
    description: "EmployeeRole delete action sheet delete option",
  });

  return () =>
    Alert.alert(
      alertTitle,
      intl.formatMessage(
        {
          defaultMessage:
            "Are you sure you want to delete {roleName}? This action cannot be undone.",
          description: "EmployeeRole delete alert description",
        },
        {
          roleName: props.name,
        }
      ),
      [
        {
          text: deleteOptionTitle,
          style: "destructive",
          onPress: onDelete,
        },
        {
          text: intl_tokens.Cancel,
          style: "cancel",
          onPress: () => {},
        },
      ]
    );
}
